function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { InfoOutlined } from "@mui/icons-material";
import { FormControl, FormControlLabel, FormHelperText, RadioGroup as MuiRadioGroup, Radio, styled } from "@mui/material";
import { useCamelCase } from "@vestwell-frontend/hooks";
import cn from "clsx";
import { createContext, useCallback, useContext, useId, useMemo, useState } from "react";
import { useUpdateEffect } from "react-use";
import { FormFieldLabel } from "./form/FormFieldLabel";
var RadioGroupContext = /*#__PURE__*/ createContext({
    variant: 'standard'
});
var StyledRadio = styled(Radio, {
    shouldForwardProp: function(prop) {
        return prop !== 'variant';
    }
})(function(props) {
    return {
        margin: props.variant === 'card' ? undefined : props.theme.spacing(1, 2)
    };
});
var StyledFormControlLabel = styled(FormControlLabel, {
    shouldForwardProp: function(prop) {
        return ![
            'fullWidth',
            'position',
            'variant'
        ].includes(prop);
    }
})(function(props) {
    return _object_spread({}, props.variant === 'card' ? _object_spread(_object_spread_props(_object_spread({
        '& .MuiFormControlLabel-label': {
            flex: 1
        },
        '& .MuiRadio-root': {
            flex: 0
        },
        alignItems: 'flex-start'
    }, props.checked ? {
        border: "1px solid ".concat(props.theme.palette.primary.main)
    } : {
        border: '1px solid transparent'
    }), {
        borderRadius: '0.437rem',
        boxShadow: props.theme.shadows[props.theme.shadows.length - 1],
        columnGap: props.theme.spacing(3),
        display: 'flex',
        flexDirection: props.position === 'left' ? 'row' : 'row-reverse',
        justifyContent: props.position === 'left' ? undefined : 'space-between',
        marginBottom: props.theme.spacing(4),
        marginRight: 0,
        maxWidth: '100%',
        padding: props.theme.spacing(3)
    }), props.fullWidth ? {
        width: '100%'
    } : {
        // todo:: old rule; should be replaced with width: 100%
        minWidth: '18.75rem'
    }) : {});
});
export var RadioButton = function(_param) {
    var className = _param.className, label = _param.label, props = _object_without_properties(_param, [
        "className",
        "label"
    ]);
    var _props_value, _props_value1;
    var ctx = useContext(RadioGroupContext);
    var onChange = useCallback(function() {
        if (!props.disabled) {
            ctx.onChange(props.value);
        }
    }, [
        ctx.onChange,
        props.disabled,
        props.value
    ]);
    return /*#__PURE__*/ _jsx(StyledFormControlLabel, _object_spread_props(_object_spread({}, props), {
        checked: ctx.value === props.value,
        className: className,
        control: /*#__PURE__*/ _jsx(StyledRadio, {
            inputProps: {
                'aria-checked': ctx.value === props.value,
                'aria-disabled': !!ctx.disabled,
                'aria-required': !!ctx.required,
                //@ts-expect-error
                'data-component': 'radioButtonInput',
                'data-testid': "".concat(ctx.name, "_").concat(useCamelCase((_props_value = props.value) === null || _props_value === void 0 ? void 0 : _props_value.toString()))
            },
            onChange: onChange,
            size: ctx.variant === 'card' ? 'medium' : 'small',
            variant: ctx.variant
        }),
        "data-component": "radioButtonLabel",
        "data-testid": "".concat(ctx.name, "_").concat(useCamelCase((_props_value1 = props.value) === null || _props_value1 === void 0 ? void 0 : _props_value1.toString())),
        disableTypography: true,
        disabled: props.disabled || !!ctx.disabled,
        fullWidth: ctx.fullWidth,
        label: label,
        position: ctx.position,
        variant: ctx.variant
    }));
};
RadioButton.displayName = 'RadioButton';
export var RadioGroup = function(_param) {
    var className = _param.className, details = _param.details, disabled = _param.disabled, error = _param.error, errorMessage = _param.errorMessage, formField = _param.formField, fullWidth = _param.fullWidth, label = _param.label, helpModal = _param.helpModal, hideLabel = _param.hideLabel, hideError = _param.hideError, info = _param.info, onChange = _param.onChange, _param_position = _param.position, position = _param_position === void 0 ? 'right' : _param_position, tmp = _param.value, initialValue = tmp === void 0 ? '' : tmp, _param_variant = _param.variant, variant = _param_variant === void 0 ? 'standard' : _param_variant, props = _object_without_properties(_param, [
        "className",
        "details",
        "disabled",
        "error",
        "errorMessage",
        "formField",
        "fullWidth",
        "label",
        "helpModal",
        "hideLabel",
        "hideError",
        "info",
        "onChange",
        "position",
        "value",
        "variant"
    ]);
    var detailsId = useId();
    var disabledId = useId();
    var helpModalId = useId();
    var errorId = useId();
    var infoId = useId();
    var labelId = useId();
    var _useState = _sliced_to_array(useState(initialValue), 2), value = _useState[0], setValue = _useState[1];
    var describedBy = "".concat(disabled ? "".concat(disabledId, " ") : '').concat(info ? "".concat(infoId, " ") : '').concat(helpModal ? "".concat(helpModalId, " ") : '').concat(details ? "".concat(detailsId, " ") : '').concat(errorMessage ? "".concat(errorId, " ") : '').trimEnd() || undefined;
    var onRadioButtonChange = useCallback(function(value) {
        setValue(value);
        if (onChange) {
            onChange(value);
        }
    }, [
        onChange
    ]);
    var ctx = useMemo(function() {
        return {
            disabled: !!disabled,
            fullWidth: !!fullWidth,
            name: props.name,
            onChange: onRadioButtonChange,
            position: position,
            required: !!props.required,
            value: value,
            variant: variant
        };
    }, [
        disabled,
        fullWidth,
        onRadioButtonChange,
        position,
        value,
        variant,
        props.name,
        props.required
    ]);
    useUpdateEffect(function() {
        setValue(initialValue);
    }, [
        initialValue
    ]);
    return /*#__PURE__*/ _jsxs(FormControl, {
        className: cn('flex', className),
        "data-component": "radioGroupControl",
        "data-testid": props.name,
        error: error,
        fullWidth: fullWidth,
        children: [
            /*#__PURE__*/ _jsx(FormFieldLabel, {
                "data-component": "radioGroupLabel",
                details: details,
                detailsId: detailsId,
                disabled: !!disabled,
                disabledId: disabledId,
                helpModal: helpModal,
                helpModalId: helpModalId,
                hideLabel: hideLabel,
                info: info,
                infoId: infoId,
                label: label,
                labelId: labelId,
                name: props.name,
                required: !!props.required
            }),
            /*#__PURE__*/ _jsx(RadioGroupContext.Provider, {
                value: ctx,
                children: /*#__PURE__*/ _jsx(MuiRadioGroup, _object_spread_props(_object_spread({}, props), {
                    "aria-describedby": describedBy,
                    "aria-disabled": !!disabled,
                    "aria-invalid": !!error,
                    "aria-labelledby": labelId,
                    "aria-required": !!props.required,
                    "data-component": "radioGroup",
                    "data-testid": props.name,
                    value: initialValue
                }))
            }),
            formField && /*#__PURE__*/ _jsx(FormHelperText, {
                "aria-atomic": "true",
                className: "mx-0",
                "data-component": "radioGroupError",
                "data-testid": props.name,
                id: errorId,
                role: "alert",
                children: !hideError && errorMessage ? /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(InfoOutlined, {
                            className: "mr-1",
                            color: "error",
                            fontSize: "small"
                        }),
                        !!label && /*#__PURE__*/ _jsxs("span", {
                            className: "sr-only",
                            children: [
                                "Error for ",
                                label,
                                ":"
                            ]
                        }),
                        errorMessage
                    ]
                }) : ' '
            })
        ]
    });
};
RadioGroup.displayName = 'RadioGroup';

//# sourceMappingURL=RadioButton.js.map